import { call, put, takeLatest, select } from 'redux-saga/effects';
import querystring from 'qs';
import {
  selectErpSystem,
  selectLanguage,
} from 'app/features/erpSystem/slice/selectors';
import { itemsActions as actions } from '.';
import { ItemsData, ItemsResponse } from './types';
import { selectAttributesData } from 'app/features/attributes/slice/selectors';
import {
  selectPaginationLimit,
  selectPaginationOffset,
} from 'app/features/pagination/slice/selectors';
import { checkValues } from 'utils/checkValues';
import {
  AttributesPayload,
  Attributes,
} from 'app/features/attributes/slice/types';
import { transformDTO } from './utils';

export function* fetchItems(action) {
  const { payload }: { payload: AttributesPayload } = action;
  const { getItemsSuccess, getItemsFail } = actions;

  try {
    const erpSystem = yield select(selectErpSystem);
    const language = yield select(selectLanguage);
    const limit = yield select(selectPaginationLimit);
    const offset = yield select(selectPaginationOffset);
    const attributes: Attributes = yield select(selectAttributesData);
    // TODO: Remove when update of attrivutes is handeled by backend API
    // For more information see comments https://eriksdigital.atlassian.net/browse/GB-713
    const modifiedValuesPayload =
      attributes && checkValues(attributes, payload);

    const itemsResponse = yield call(
      fetch,
      `/gasket-configurator/api/items?${querystring.stringify(
        { erpSystem, lang: language, limit, offset, ...modifiedValuesPayload },
        { arrayFormat: 'comma' },
      )}`,
    );

    if (itemsResponse.status !== 200) {
      return yield put(getItemsFail('failed to fetch'));
    } else {
      const items: ItemsResponse = yield itemsResponse.json();
      const itemsTransformed: ItemsData = yield transformDTO(items);
      if (!itemsTransformed) {
        return yield put(getItemsFail('No items fetched'));
      }

      return yield put(getItemsSuccess(itemsTransformed));
    }
  } catch (e) {
    yield put(getItemsFail(e));
  }
}
export function* itemsSaga() {
  yield takeLatest(actions.getItems.type, fetchItems);
}
